import Hades from '@adoratorio/hades';

const hades = {
  ref: null,
  init() {
    hades.ref = new Hades({
      mode: Hades.MODE.VIRTUAL,
      container: document.querySelector('.page'),
      viewport: document.querySelector('.view.main'),
      easing: {
        duration: 2000,
        mode: Hades.EASING.QUINT,
      },
      autoBoundries: false,
      boundries: Hades.createBoundries(
        0, 0, 0,
        document.querySelector('.page').getBoundingClientRect().height - window.innerHeight,
      ),
      renderScroll: true,
      scale: 1,
      touchMultiplier: 2,
      scrollbar: null,
    });
    return hades;
  },

  resize() {
    hades.ref.boundries = Hades.createBoundries(
      0, 0, 0,
      document.querySelector('.page').getBoundingClientRect().height - window.innerHeight,
    );
  },
};

export default hades;
